import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Careers() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Animation happens only once
    });
  }, []);
  return (
    <div>
      <section id="contact" className="contact section">
        {/* Section Title */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Careers</h2>
          <p>Join us in funding the future of innovation!</p>
        </div>
        {/* End Section Title */}

        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4">
            <div className="col-lg-4">
              <h3>Open Positions</h3>
              <p>There are no current openings</p>
              {/* <p>1. Marketing Specialist- 10-12 Yrs Experience <button className="btn btn-primary">Apply</button></p> 
                <p>2. Marketing Specialist- 10-12 Yrs Experience <button className="btn btn-primary">Apply</button></p> 
                <p>3. Marketing Specialist- 10-12 Yrs Experience <button className="btn btn-primary">Apply</button></p>  */}
            </div>
            <div className="col-lg-8">
              <form
                action="forms/contact.php"
                method="post"
                class="php-email-form"
                // data-aos="fade-up"
                //   data-aos-delay="400"
              >
                <div class="row gy-4">
                  <div class="col-md-6">
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder="Your Name"
                      required=""
                    />
                  </div>

                  <div class="col-md-6 ">
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      placeholder="Your Email"
                      required=""
                    />
                  </div>
                  <div class="col-md-6">
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder="Your Age"
                      required=""
                    />
                  </div>
                  <div class="col-md-6">
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder="Your Contact Number"
                      required=""
                    />
                  </div>

                  <div class="col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      name="subject"
                      placeholder="Position Applied for"
                      required=""
                    />
                  </div>

                  <div class="col-md-12">
                    <textarea
                      class="form-control"
                      name="message"
                      rows="6"
                      placeholder="Profile Summary"
                      required=""
                    ></textarea>
                  </div>

                  <div class="col-md-12 text-center">
                    <div class="loading">Loading</div>
                    <div class="error-message"></div>
                    <div class="sent-message">
                      Your message has been sent. Thank you!
                    </div>

                    <button type="submit">Apply</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Careers;
